export default "__VITE_ASSET__BEGM$dR3__"